import {
  CartesianGrid,
  ComposedChart,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import Panel from "./Panel.jsx";
import { formatUsd } from "../lib/utils/formatters.js";

export default function MainChart({ data = [], support, resistance }) {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <Panel title="График XAU/USD" icon="chart" className="min-h-[440px]">
      {hasData ? (
        <div className="h-[360px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ top: 8, right: 12, bottom: 8, left: 0 }}>
              <CartesianGrid stroke="rgba(255,255,255,0.08)" vertical={false} />
              <XAxis
                dataKey="date"
                tick={{ fill: "#8f9bae", fontSize: 12 }}
                tickLine={false}
                axisLine={{ stroke: "rgba(255,255,255,0.12)" }}
                minTickGap={24}
              />
              <YAxis
                tick={{ fill: "#8f9bae", fontSize: 12 }}
                tickLine={false}
                axisLine={false}
                width={74}
                domain={["dataMin - 40", "dataMax + 40"]}
                tickFormatter={(value) => `$${Math.round(value)}`}
              />
              <Tooltip content={<ChartTooltip />} />
              <Line type="monotone" dataKey="bollingerUpper" stroke="rgba(118,199,232,0.45)" dot={false} strokeWidth={1} />
              <Line type="monotone" dataKey="bollingerLower" stroke="rgba(118,199,232,0.45)" dot={false} strokeWidth={1} />
              <Line type="monotone" dataKey="price" stroke="#f3d98a" dot={false} strokeWidth={2.4} name="Цена золота" />
              <Line type="monotone" dataKey="ema9" stroke="#67d7a1" dot={false} strokeWidth={1.5} name="EMA 9" />
              <Line type="monotone" dataKey="ema21" stroke="#76c7e8" dot={false} strokeWidth={1.5} name="EMA 21" />
              <Line type="monotone" dataKey="ema50" stroke="#ff7b8a" dot={false} strokeWidth={1.3} name="EMA 50" />
              {support ? <ReferenceLine y={support} stroke="#67d7a1" strokeDasharray="5 5" label={{ value: "Поддержка", fill: "#67d7a1", fontSize: 12 }} /> : null}
              {resistance ? <ReferenceLine y={resistance} stroke="#ff7b8a" strokeDasharray="5 5" label={{ value: "Сопротивление", fill: "#ff7b8a", fontSize: 12 }} /> : null}
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="flex h-[360px] items-center justify-center rounded-md border border-white/10 bg-white/[0.03] text-sm text-slate-400">
          Данные графика недоступны.
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-3 text-xs text-slate-400">
        <Legend color="#f3d98a" label="Цена золота" />
        <Legend color="#67d7a1" label="EMA 9" />
        <Legend color="#76c7e8" label="EMA 21" />
        <Legend color="#ff7b8a" label="EMA 50" />
        <Legend color="rgba(118,199,232,0.45)" label="Bollinger Bands" />
      </div>
    </Panel>
  );
}

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-md border border-white/10 bg-ink/95 p-3 shadow-panel">
      <div className="mb-2 text-xs font-semibold text-slate-300">{label}</div>
      {payload
        .filter((item) => item.value != null)
        .slice(0, 8)
        .map((item) => (
          <div key={item.dataKey} className="flex min-w-[170px] items-center justify-between gap-4 text-xs">
            <span style={{ color: item.color }}>{item.name ?? item.dataKey}</span>
            <span className="font-semibold text-white">{formatUsd(item.value)}</span>
          </div>
        ))}
    </div>
  );
}

function Legend({ color, label }) {
  return (
    <span className="inline-flex items-center gap-2">
      <span className="h-2 w-2 rounded-full" style={{ background: color }} />
      {label}
    </span>
  );
}
